import * as React from 'react';
import { observer } from 'mobx-react';

// Components
import Button from '../../components/Button';
import Toolbar from '../../components/Toolbar';
import Typography from '../../components/Typography';

// Component
export interface IProps {
  selectedPeople: number;
  onCreate: () => void;
  onCancel: () => void;
}

function CreateQuestionToolbar(props: IProps) {
  return (
    <Toolbar>
      <Typography type="title" style={{ flexGrow: 1 }}>
        {props.selectedPeople === 0
          ? 'Select People'
          : `${props.selectedPeople} Selected People`}
      </Typography>
      <Button style={{ marginRight: 16 }} onClick={props.onCancel}>
        Cancel
      </Button>
      <Button raised={true} color="primary" onClick={props.onCreate}>
        Create Question
      </Button>
    </Toolbar>
  );
}

export default observer(CreateQuestionToolbar);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/AppNetworkPeopleSearch/CreateQuestionToolbar.tsx